var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toTop",class:{ toTopHide: _vm.toTopHide },style:({ backgroundColor: 'rgba(255, 255, 255, ' + _vm.opacity + ')' }),on:{"touchstart":function($event){$event.preventDefault();return _vm.toTop($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }